/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {DefaultAvatarIcon} from '@ion/dls/src/icons/DefaultAvatarIcon';
import {ScDeviceIcon} from '@ion/dls/src/icons/ScDeviceIcon';

// functional implementation to define styles for the avatar component
export function selectStyle(classes, AvatarIconSize, size) {
  const {small, medium, large, extraLarge, max} = AvatarIconSize;
  const map = {
    [AvatarIconSize.small]      : classes.small,
    [AvatarIconSize.medium]     : classes.medium,
    [AvatarIconSize.large]      : classes.large,
    [AvatarIconSize.extraLarge] : classes.custom,
    [AvatarIconSize.max]        : classes.custom
  };
  return map[size] || classes.default;
}
export type DefineChildrenParams = {
  AvatarIconSize, IconSize, Color, name, size, isDevice, Initials
}

// functional implementation to define styles for the children elements of avatar
export function defineChildren({
  AvatarIconSize,
  IconSize,
  Color,
  name,
  size,
  isDevice = false,
  Initials
}: DefineChildrenParams) {
  const {small, medium, large} = AvatarIconSize;
  const map = {
    [AvatarIconSize.small]      : IconSize.small,
    [AvatarIconSize.medium]     : IconSize.medium,
    [AvatarIconSize.large]      : IconSize.large,
    [AvatarIconSize.extraLarge] : IconSize.medium,
    [AvatarIconSize.max]        : IconSize.medium
  };
  const color = {
    [AvatarIconSize.small]      : Color.grey3,
    [AvatarIconSize.medium]     : Color.white,
    [AvatarIconSize.large]      : Color.aaBlue,
    [AvatarIconSize.extraLarge] : Color.white,
    [AvatarIconSize.max]        : Color.white
  };
  if (isDevice) {
    return <ScDeviceIcon size={map[size] || IconSize.medium} color={color[size] || Color.white} />;
  }
  return name ? <Initials label={name} /> : (<DefaultAvatarIcon size={map[size] || IconSize.medium}
    color={color[size] || Color.white} />);
}
